/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import { SubPage, Group, Copy, Title, Form, Grid, GridSet, GridItem, TextField, EditInfoCTA } from '@insticator/insticator-ui'; // iui-material
//styles
import styles from 'pages/dashboard/account/general/general_styles';
import injectSheet from 'react-jss';



/* ========== ~~~~~~~~~~ ACCOUNT GENERAL INFO ~~~~~~~~~~ ========== */
class General extends Component {
    constructor(props) {
        super(props);
        this.formName = 'generalInformation';
    }
    componentWillMount(){
        this.props.getGeneralInfoOrRepopulate(this.props.hasStoredData, this.props.accountUUID);
    }
    handleSave = () => {
        this.props.updateGeneralInformationWithValidation(this.props.fields, this.getFormCallData(), this.props.accountUUID);
    };
    getFormCallData = () => ({
        accountName: this.props.fields.name.value,
        streetAddress: this.props.fields.address.value,
        city: this.props.fields.city.value,
        zipCode: this.props.fields.zip.value,
        region: this.props.fields.state.value,
        country: this.props.fields.country.value
    });
    render() {
        const { address, city, country, name, state, zip } = this.props.fields;
        return(
            <SubPage name={`general`} klass={this.props.classes.general}>
                <Form name={this.formName} editable={this.props.editable} processing={this.props.savingData}>
                    <Copy name={`page-copy`}>
                        <Title variant={'withctas'}>
                            <h2>General Information</h2>
                            <EditInfoCTA formName={this.formName}
                                        editable={this.props.editable}
                                        savingData={this.props.savingData}
                                        saveFormData={this.handleSave}/>
                        </Title>
                    </Copy>
                    <Group name={`page-details`}>
                        <Grid type={`fields`}>
                            <GridSet direction={`horizontal`}>
                                <GridItem><TextField type={`text`} name={`name`} formName={this.formName} placeholder={`Name`} label={`Account Name`} info={``} value={name.value} valid={name.valid} formDisabled={!this.props.editable} required /></GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`}>
                                <GridItem><TextField type={`text`} name={`address`} formName={this.formName} placeholder={`Street adress`} label={`Company Address`} info={``} value={address.value} formDisabled={!this.props.editable} valid={address.valid} required /></GridItem>
                                <GridItem><TextField type={`text`} name={`city`} formName={this.formName} placeholder={`City`} label={`City`} info={``} value={city.value} valid={city.valid} formDisabled={!this.props.editable} required /></GridItem>
                                <GridItem><TextField type={`text`} name={`zip`} formName={this.formName} placeholder={`11111`} label={`Zip Code`} info={``} value={zip.value} valid={zip.valid} formDisabled={!this.props.editable} required /></GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`}>
                                <GridItem><TextField type={`text`} name={`state`} formName={this.formName} placeholder={`State/Providence`} label={`State/Providence`} info={``} value={state.value} formDisabled={!this.props.editable} valid={state.valid} required /></GridItem>
                                <GridItem><TextField type={`text`} name={`country`} formName={this.formName} placeholder={`Country`} label={`Country`} info={``} value={country.value} valid={country.valid} formDisabled={!this.props.editable} required /></GridItem>
                            </GridSet>
                        </Grid>
                    </Group>
                </Form>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(General);
